import { FETCH_STATUSES } from '../base/types';
import { AppState } from '../index';

export const residentSearchSelector = (state: AppState) =>
  state.residentSearch.data || [];
export const residentSearchLoadingSelector = (state: AppState) =>
  state.residentSearch.status === FETCH_STATUSES.LOADING;
